/* eslint-disable @typescript-eslint/quotes */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable prefer-const */
import { Horse } from "./horse";
import { AccountRole } from "./accountRole";
import { AccountMembership } from './accountMembership';
import { Stat } from "./stat";
import { Trade } from './trade';
import { Notification } from './notification';
import { ScheduledNotification } from './scheduledNotification';
import { AccountFamily } from "./accountFamily";
import { MediaItem } from "./media-item";
import { AccountDocument } from "./account-document";

export class Account {
    id: number;
    emailAddress: string = '';
    male: boolean;
    firstName: string = '';
    lastName: string = '';
    displayName: string = '';
    profilePicFileName: string;
    birthDate: string = '';
    phone: string = '';
    streetAddress: string = '';
    city: string = '';
    state: string;
    zip: string = '';
    country: string = '';
    taxDocumentFileName: string;
    taxDocumentUploadedOn?: string;
    birthCertificateFilename: string;
    birthCertificateUploadedOn?: string;
    documents: AccountDocument[] = [];

    familyMembers: AccountFamily[] = [];
    memberships: AccountMembership[] = [];

    youths: Account[] = [];
    horses: Horse[] = [];
    videos: MediaItem[] = [];
    photos: MediaItem[] = [];
    roles: AccountRole[] = [];
    stats: Stat[] = [];
    outgoingTrades: Trade[] = [];
    incomingTrades: Trade[] = [];
    scheduledNotifications: ScheduledNotification[] = [];
    notifications: Notification[] = [];
    stripeCustomerId: string;
    stripeCustomerId_Test: string;

    public static create(item: Account): Account {
        let account = new Account();
        Object.keys(item).forEach(key => {
            account[key] = item[key];
        });
        return account;
    }

    public static createDTO(item: Account): Account {
        let account = Account.create(item);

        account.notifications = [];
        account.scheduledNotifications = [];
        account.incomingTrades = [];
        account.outgoingTrades = [];
        account.documents = [];

        account.familyMembers = [];
        account.memberships = [];
    
        account.youths = [];
        account.horses = [];
        account.videos = [];
        account.photos = [];
        account.roles = [];
        account.stats = [];

        return account;
    }
}
